import { TabName } from "./Views/OrderEditor/OrderEditorTabs";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardHeader from "@mui/material/CardHeader";
import NoteIcon from "@mui/icons-material/Note";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { Button, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { IEmployee } from "../Interfaces/Admin/IEmployee";
import Typography from "@mui/material/Typography";
import { v4 } from 'uuid';
import { addApplicationNotes } from "../Data/ApplicationData";
import NotePopup from "./NotePopup";
import { ApplicationDispatch } from "../store/application/types";
import { sort } from "ramda";
import { IApplicationNotes } from "../Interfaces/Application/IApplicationNotes";
import { getEmployeeName } from "../utils/utils";
import { AppState } from "../store/rootReducer";
import NotesDialog from "./Views/OrderEditor/NotesDialog";
import { canUpdateApp } from "../utils/appUtils";
import { useBusinessRulesEngine } from "../Data/BusinessRulesData";
import { showValidationDialog } from "../utils/ValidationDialog";

interface NotesCardProps {
  navigate: (tabName: TabName) => void;
}

export const NotesCard: React.FC<NotesCardProps> = (props) => {
  const currentApp = useSelector((state: AppState) => state.applications.editingApp);
  const applicationNotes = currentApp?.applicationNotes.filter(an => !an.deleted);
  const employees: IEmployee[] = useSelector((state: AppState) => state.applications.employees);
  const [showNotesPopup, setShowNotesPopup] = useState<boolean>(false);
  const activeUser: IEmployee = useSelector((state: AppState) => state.applications.loggedInUser!.employee);
  const dispatch = useDispatch<ApplicationDispatch>();
  const businessRulesEngine = useBusinessRulesEngine();

  const handleAddNotes = (notes: { note: string, isDecisionNote: boolean, createdDate: Date }[], bypassAppRequirements?: boolean): void => {
    const result = businessRulesEngine({
      action: "Notes",
    });
    if (result?.errors?.length && !bypassAppRequirements) {
      showValidationDialog({
        errors: result.errors,
        callback: () => handleAddNotes(notes, true),
      });
    } else {
      addApplicationNotes(currentApp!.id, notes, dispatch);
      setShowNotesPopup(false);
    }
  };
  return (
    <>
      {currentApp &&
        <>
          <Card>
            <CardHeader
              avatar={<NoteIcon fontSize="small" />}
              title="Notes"
              action={
                <>
                  <Tooltip title="Add Note">
                    <IconButton
                      color="inherit"
                      style={{ marginRight: 15 }}
                      onClick={() => {
                        setShowNotesPopup(true);
                      }}
                    >
                      <AddIcon style={{ color: `primary`, marginRight: `5px` }} />
                    </IconButton>
                  </Tooltip>
                  <IconButton size="small" onClick={() => props.navigate("Notes")}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </>
              }
            />
            <Divider variant="middle" />
            <CardContent style={{ display: 'flex', flexDirection: "column-reverse" }}>
              {applicationNotes && sort((left: IApplicationNotes, right: IApplicationNotes) =>
                new Date(left.createdDate) > new Date(right.createdDate) ? -1
                  : new Date(left.createdDate) < new Date(right.createdDate) ? 1
                    : 0
                , applicationNotes
              ).map((an, key) => {
                const isNoteFromCurrentUser = activeUser.id === an.employeeId;
                return (
                  <div
                    key={key}
                    style={{
                      display: 'flex',
                      flexDirection: isNoteFromCurrentUser ? 'row-reverse' : 'row'
                    }}
                  >
                    <Card style={{
                      marginBottom: "5px",
                      width: "100%",
                      backgroundColor: isNoteFromCurrentUser ? '#e6fde5' : 'aliceblue'
                    }}>
                      <CardHeader
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              height: "0px",
                              paddingTop: "5px"
                            }}
                          >
                            <Typography style={{ fontWeight: "bold" }} variant="subtitle1">
                              {getEmployeeName(employees, an.employeeId)}
                            </Typography>
                            <Typography variant="caption">
                              {new Date(an.createdDate).toLocaleString()}
                            </Typography>
                          </div>
                        }
                      />
                      <CardContent>
                        {an.note}
                      </CardContent>
                    </Card>
                  </div>
                );
              })}
            </CardContent>
          </Card>
          <NotesDialog
            notes={currentApp.applicationNotes}
            employee={activeUser}
            canAddNote={true}
            open={showNotesPopup}
            onSave={handleAddNotes}
            mode='single'
            onClose={() =>
              setShowNotesPopup(false)
            }
          />
          {/* <NotePopup
            open={showNotesPopup}
            addNote={(note: string) => {
              // Add new note to this application.
              const newNote = {
                id: v4(),
                applicationId: currentApp.id,
                employeeId: activeUser.id,
                employee: activeUser,
                note: note,
                deleted: false,
                createdDate: new Date(),
                modifiedDate: null,
              };
              addApplicationNotes(currentApp!.id, [newNote], dispatch);
              // Close the popup.
              setShowNotesPopup(false);
            }}
            onClose={() => setShowNotesPopup(false)}
          /> */}
        </>
      }
    </>
  );
}